import IntegrationAppLogo from './images/integration-app-logo.svg'
import IntegrationAppIcon from './images/integration-app-icon.svg'

import { AlternativeType } from '../types'

export const alternative: AlternativeType = {
  name: 'Integration App',
  logo: IntegrationAppLogo,
  icon: IntegrationAppIcon,
  comparison_table: {
    non_developer_support: 'Drag-and-drop workflow builder or YAML editor',
    developer_support: 'API-first: Full access to all functionality',
    on_premise_option: true,
    end_user_ui:
      'Iframe with custom styles, React components, or fully custom UI',
    connector_library: '~1500',
    custom_connectors:
      'Fully supported (full-access to any API operations, trigger, custom fields)',
  },
}
